import { categoriasPet } from '../../helpers/funcoesAuxiliares';
import { verificarExcecaoPetPorLocalidade } from '../validadoresComunsPorPlano/excecoes';
import {
    retornaLabelDoValorParentesco, validatorAte64Anos,
    validatorConjugeAte64Anos,
    validatorMaior79Anos,
    validatorPaiMaior79Anos,
    validatorDependentesQuePodemSemOuComAdicionalMaior79,
    validatorMaeMaior79Anos,
    validatorConjugeMaior79Anos,
    validatorPadrastoMaior79,
    validatorExConjugeMaior79,
    validatorMadrastaMaior79,
    validatorConjugeMaiorIgual65Anos,
    validatorDependenteSemValorAdicional,
    validatorDependentesQuePodemSemOuComAdicionalAte64,
    validatorDependentesQuePodemSemOuComAdicionalMaiorIgual65,
    validatorExConjugeMaiorIgual65,
    validatorMadrastaMaiorIgual65, validatorMaeMaiorIgual65Anos,
    validatorMaiorIgual65Anos,
    validatorPadrastoMaiorIgual65,
    validatorPaiMaiorIgual65Anos,
    validatorParentescoEmDuplicidadeEdicao,
    validatorParentescosComRegrasEspeciaisAte64,
    validatorSomenteEsposoSemExConjuge, validatorPaiAte64Anos, validatorMaeAte64Anos,
    validatorSomenteMaeSemMadrasta,
    validatorSomentePaiSemPadrasto
} from './funcoesAuxiliaresZE';

export class CorrenteEdicaoZE {
    constructor(
        dependentes,
        parentesco,
        categorias,
        valoresForm,
        valoresAnterioresForm
    ) {
        this.dependentes = dependentes;
        this.parentesco = parentesco;
        this.categorias = categorias;
        this.arrayMsgsErro = [];
        this.valoresForm = valoresForm;
        this.valoresAnterioresForm = valoresAnterioresForm;
        this.possuiDependendenteTipoEsposo = this.verificarPossuiDependenteTipoEsposo();
        this.maximoDependentesPet = 1;
    }

    verificarPossuiDependenteTipoEsposo() {
        const dependenteTipoEsposo = this.dependentes.find(dependente => dependente.Parentesco === 'ESPOSO(A)');

        return dependenteTipoEsposo;
    }

    infringeParentescoSemAdicional() {
        if (validatorDependenteSemValorAdicional(this.valoresForm)) {
            this.arrayMsgsErro.push('Dependentes do tipo Pais, Filhos, Cônjuge, Sogro (a), Enteados e Adotivos só podem ser inseridos SEM VALOR ADICIONAL.');
        }

        return this;
    }

    infringeParentescoComAdicionalAte64() {
        const parentescoTipoExConjuge = '32';

        if (validatorAte64Anos(this.valoresForm) && this.valoresForm.Parentesco !== parentescoTipoExConjuge) {
            this.arrayMsgsErro.push('Para dependentes do tipo Irmã (o), Sobrinho (a), Outros, Neto (a), Primo (a), Tio (a), Avo e Pet (animal) até 64 anos, o adicional permitido é o ZELO ATÉ 64 ANOS.');
        }

        return this;
    }

    infringeParentescoComAdicionalMaiorIgual65() {
        const parentescoTipoExConjuge = '32';

        if (validatorMaiorIgual65Anos(this.valoresForm) && this.valoresForm.Parentesco !== parentescoTipoExConjuge) {
            this.arrayMsgsErro.push('Para dependentes do tipo Irmã (o), Sobrinho (a), Outros, Neto (a), Primo (a), Tio (a), Avo e Pet (animal) acima de 65 anos, o adicional permitido é o ZELO MAIOR 65 ANOS.');
        }

        return this;
    }

    infringeParentescoComAdicionalMaior79() {
        const parentescoTipoExConjuge = '32';

        if (validatorMaior79Anos(this.valoresForm) && this.valoresForm.Parentesco !== parentescoTipoExConjuge) {
            this.arrayMsgsErro.push('Para dependentes do tipo Irmã (o), Sobrinho (a), Outros, Neto (a), Primo (a), Tio (a), Avo e Pet (animal) acima de 79 anos, o adicional permitido é o ZELO MAIOR 79 ANOS.');
        }

        return this;
    }

    infringeConjugeMaiorComAdicionalMaior79() {
        if (validatorConjugeMaior79Anos(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Ex-Conjuge e queira adicionar um dependente do tipo Esposo(A) acima de 79 anos é necessário o adicional ZELO MAIOR 79 ANOS.');
        }

        return this;
    }

    infringemaeComAdicionalMaior79() {
        if (validatorMaeMaior79Anos(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Madrasta e queira adicionar um dependente do tipo Mãe maior que 79 anos é necessário o adicional ZELO ATÉ 79 ANOS.');
        }

        return this;
    }

    exConjugeComAdicionalMaiorIgual65() {
        if (validatorExConjugeMaiorIgual65(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Esposo (a) e queira adicionar um dependente do tipo Ex-conjuge acima de 79 anos é necessário o adicional ZELO MAIOR 79 ANOS.');
        }

        return this;
    }

    infringeExConjugeComAdicionalMaior79() {
        if (validatorExConjugeMaior79(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Esposo (a) e queira adicionar um dependente do tipo Ex-conjuge acima de 79 anos é necessário o adicional ZELO MAIOR 79 ANOS.');
        }

        return this;
    }

    infringePaiComAdicionalMaior79() {
        if (validatorPaiMaior79Anos(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Padrasto e queira adicionar um dependente do tipo Pai maior que 79 anos é necessário o adicional ZELO MAIOR 79 ANOS.');
        }

        return this;
    }

    infringeMadrastaComAdicionalMaior79() {
        if (validatorMadrastaMaior79(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo MÃE e queira adicionar um dependente do tipo MADRASTA acima de 65 anos é necessário o adicional ZELO MAIOR 65 ANOS.');
        }

        return this;
    }

    infringepadrastoComAdicionalMaior79() {
        if (validatorPadrastoMaior79(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo PAI ou PADRASTO sem adicional e queira adicionar um dependente do tipo PADRASTO maior que 79 anos é necessário o adicional ZELO MAIOR 79 ANOS.');
        }

        return this;
    }

    infringeparentescosComAdicionalElegivelMaior79() {
        if (validatorDependentesQuePodemSemOuComAdicionalMaior79(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Para dependentes do tipo Ex-conjuge, Madrasta e/ou Padastro maior que 79 anos, e que não possuam um dependente de grau equivalente sem valor adicional, é permitido SEM VALOR ADICIONAL ou ZELO MAIOR 79.');
        }

        return this;
    }

    permitirSomenteConjugeSemValorAdicional() {
        if (validatorSomenteEsposoSemExConjuge(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Só são permitidos conjuges com valor adicional caso exista um Ex-conjuge sem valor adicional cadastrado.');
        }

        return this;
    }

    permitirSomenteMaeSemValorAdicional() {
        if (validatorSomenteMaeSemMadrasta(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Só é permitido parentesco do tipo Mãe com valor adicional caso exista uma Madrasta sem valor adicional cadastrada.');
        }

        return this;
    }

    permitirSomentePaiSemValorAdicional() {
        if (validatorSomentePaiSemPadrasto(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Só é permitido parentesco do tipo Pai com valor adicional caso exista um Padrasto sem valor adicional cadastrado.');
        }

        return this;
    }

    parentescoComAdicionalAte64() {
        const parentescoTipoExConjuge = '32';

        if (validatorAte64Anos(this.valoresForm) && this.valoresForm.Parentesco !== parentescoTipoExConjuge && this.valoresForm.Parentesco !== '10' && this.valoresForm.Parentesco !== '02') {
            this.arrayMsgsErro.push('Para dependentes do tipo Irmã (o), Sobrinho (a), Outros, Neto (a), Primo (a), Tio (a), Avo e Pet (animal) até 64 anos, o adicional permitido é o ZELO ATÉ 64 ANOS.');
        }

        return this;
    }

    parentescoComAdicionalMaiorIgual65() {
        const parentescoTipoExConjuge = '32';

        if (validatorMaiorIgual65Anos(this.valoresForm) && this.valoresForm.Parentesco !== parentescoTipoExConjuge) {
            this.arrayMsgsErro.push('Para dependentes do tipo Irmã (o), Sobrinho (a), Outros, Neto (a), Primo (a), Tio (a), Avo e Pet (animal) acima de 65 anos, o adicional permitido é o ZELO MAIOR 65 ANOS.');
        }

        return this;
    }

    conjugeComAdicionalAte64() {
        if (validatorConjugeAte64Anos(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Ex-Conjuge e queira adicionar um dependente do tipo Esposo(A) até 64 anos é necessário o adicional ZELO ATÉ 64 ANOS.');
        }

        return this;
    }

    conjugeComAdicionalMaiorIgual65() {
        if (validatorConjugeMaiorIgual65Anos(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Ex-Conjuge e queira adicionar um dependente do tipo Esposo(A) acima de 65 anos é necessário o adicional ZELO MAIOR 65 ANOS.');
        }

        return this;
    }

    maeComAdicionalAte64() {
        if (validatorMaeAte64Anos(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Madrasta e queira adicionar um dependente do tipo Mãe até 64 anos é necessário o adicional ZELO ATÉ 64 ANOS.');
        }

        return this;
    }

    maeComAdicionalMaiorIgual65() {
        if (validatorMaeMaiorIgual65Anos(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Madrasta e queira adicionar um dependente do tipo Mãe acima de 65 anos é necessário o adicional ZELO MAIOR 65 ANOS.');
        }

        return this;
    }

    paiComAdicionalAte64() {
        if (validatorPaiAte64Anos(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Padrasto e queira adicionar um dependente do tipo Pai até 64 anos é necessário o adicional ZELO ATÉ 64 ANOS.');
        }

        return this;
    }

    paiComAdicionalMaiorIgual65() {
        if (validatorPaiMaiorIgual65Anos(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Padrasto e queira adicionar um dependente do tipo Pai acima de 65 anos é necessário o adicional ZELO MAIOR 65 ANOS.');
        }

        return this;
    }

    exConjugeComAdicionalAte64() {
        if (validatorParentescosComRegrasEspeciaisAte64(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Esposo (a) e queira adicionar um dependente do tipo Ex-conjuge até 64 anos é necessário o adicional ZELO ATÉ 64 ANOS.');
        }

        return this;
    }

    madrastaComAdicionalAte64() {
        if (validatorParentescosComRegrasEspeciaisAte64(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo MÃE e queira adicionar um dependente do tipo MADRASTA até 64 anos é necessário o adicional ZELO ATÉ 64 ANOS.');
        }

        return this;
    }

    madrastaComAdicionalMaiorIgual65() {
        if (validatorMadrastaMaiorIgual65(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo MÃE e queira adicionar um dependente do tipo MADRASTA acima de 65 anos é necessário o adicional ZELO MAIOR 65 ANOS.');
        }

        return this;
    }

    padrastoComAdicionalAte64() {
        if (validatorParentescosComRegrasEspeciaisAte64(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo PAI e queira adicionar um dependente do tipo PADRASTO até 64 anos é necessário o adicional ZELO ATÉ 64 ANOS.');
        }

        return this;
    }

    padrastoComAdicionalMaiorIgual65() {
        if (validatorPadrastoMaiorIgual65(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo PAI e queira adicionar um dependente do tipo PADRASTO acima de 65 anos é necessário o adicional ZELO MAIOR 65 ANOS.');
        }

        return this;
    }

    parentescosComAdicionalElegivelAte64() {
        if (validatorDependentesQuePodemSemOuComAdicionalAte64(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Para dependentes do tipo Ex-conjuge, Madrasta e/ou Padastro até 64 anos, e que não possuam um dependente de grau equivalente sem valor adicional, é permitido SEM VALOR ADICIONAL ou ZELO ATÉ 64.');
        }

        return this;
    }

    parentescosComAdicionalElegivelAte65() {
        if (validatorDependentesQuePodemSemOuComAdicionalMaiorIgual65(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Para dependentes do tipo Ex-conjuge, Madrasta e/ou Padastro acima de 65 anos, e que não possuam um dependente de grau equivalente sem valor adicional, é permitido SEM VALOR ADICIONAL ou ZELO MAIOR 65 ANOS.');
        }

        return this;
    }

    parentescoEmDuplicidade() {
        if (validatorParentescoEmDuplicidadeEdicao(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push(`${retornaLabelDoValorParentesco(this.parentesco)}`);
        }

        return this;
    }

    excecaoPetPorLocalidade() {
        if (verificarExcecaoPetPorLocalidade(this.valoresForm.Categoria.trim(), this.valoresForm.Parentesco.trim())) {
            this.arrayMsgsErro = [];
        }

        return this;
    }

    permitirDependentePetSomenteComAdicionalPet() {
        if (this.valoresForm.Parentesco.trim() === 'PET' && !categoriasPet.includes(this.valoresForm.Categoria.trim())) {
            this.arrayMsgsErro.push('Somente é permitido dependente PET que tenha como adicional referente ao PET');
        }

        return this;
    }

    limitarQuantidadePet() {
        const numeroDependentesPet = this.dependentes.filter(dependente => dependente['GrauParentesco.Grau'].trim() === 'PET').length;

        if (this.valoresForm.Parentesco.trim() === 'PET' && this.valoresAnterioresForm.Parentesco !== 'PET') {
            if (numeroDependentesPet >= this.maximoDependentesPet) {
                this.arrayMsgsErro.push(`Só é permitido um dependente do tipo ${this.valoresForm.Parentesco}.`);
            }
        }

        return this;
    }
}
